// =====================================================================
// PropertyDetailHero.jsx
// =====================================================================
// Hero card for /operational/:location — type/model/start-date pill + 4 latest-month KPIs.
// Extracted from PropertyDetail.jsx (iter-35e split).
// =====================================================================

import { MapPin, Calendar } from "lucide-react";

export default function PropertyDetailHero({ location, data, latest }) {
  return (
    <div className="bg-brand-ink text-white p-6 mb-4 relative overflow-hidden" data-testid="property-hero">
      <div className="absolute inset-0 dotted-grid opacity-20" />
      <div className="relative grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div className="lg:col-span-2">
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-brand-yellow flex items-center gap-3">
            <span className="bg-brand-yellow text-brand-ink px-1.5 py-0.5">{data.type}</span>
            <span>{data.model}</span>
            <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> Operational since {data.start_date?.slice(0, 7)}</span>
          </div>
          <h1 className="font-display font-black text-5xl tracking-tight mt-3 leading-none">{location}</h1>
          <div className="flex items-center gap-2 text-zinc-400 mt-3 text-sm">
            <MapPin className="w-3 h-3" /> {latest?.city || "—"}, {latest?.state || "—"}
          </div>
        </div>
        {latest && (
          <div className="grid grid-cols-2 lg:grid-cols-2 gap-3 lg:col-span-2">
            <HeroKpi label="Latest occupancy" value={`${latest.occupancy_pct}%`} highlight />
            <HeroKpi label="Beds" value={latest.capacity_beds} />
            <HeroKpi label="RevPAB" value={`₹${latest.revpab}`} />
            <HeroKpi label="ADR" value={`₹${latest.adr}`} />
          </div>
        )}
      </div>
    </div>
  );
}

function HeroKpi({ label, value, highlight = false }) {
  return (
    <div className="border-l-2 border-brand-yellow pl-3">
      <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-400">{label}</div>
      <div className={`font-display font-black text-3xl ${highlight ? "text-brand-yellow" : ""}`}>{value}</div>
    </div>
  );
}
